/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserPinDto } from '../../models/user-pin-dto';

export interface ListMyUserPins$Params {
  'X-API-Version'?: string;
}

export function listMyUserPins(http: HttpClient, rootUrl: string, params?: ListMyUserPins$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserPinDto>>> {
  const rb = new RequestBuilder(rootUrl, listMyUserPins.PATH, 'get');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserPinDto>>;
    })
  );
}

listMyUserPins.PATH = '/api/user-pins/my';
